module.exports = __webpack_public_path__ + "static/02-07a75ec81bf20e79570e544ae4ac9e8d.jpg";